import { render, staticRenderFns } from "./ReferentielProduitCerealeView.vue?vue&type=template&id=36b1cf6a"
import script from "./ReferentielProduitCerealeView.vue?vue&type=script&lang=js"
export * from "./ReferentielProduitCerealeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports